
<script>
export default {
    name: 'forminho',

    data()
    {
        return {
            sent: false,
            error: false,
            agreement: false,
            isNotAgreed: false,
        }
    },

    mounted()
    {
        const scriptURL = 'https://script.google.com/macros/s/AKfycbxQGdvDWiZzmKMqYngjmWMQBmKVVv49_mqYImUu84auvDVF79w/exec'
        const form = document.forms['submit-to-google-sheet']

        form.addEventListener('submit', e => {
            e.preventDefault()
            if(this.agreement)
            {
                this.isNotAgreed = false
                fetch(scriptURL, { method: 'POST', body: new FormData(form)})
                .then(() => this.sent = true)
                .catch(()=>{this.error = true})
            } else {
                this.isNotAgreed = true
            }
        })
    }
}
</script>

<template lang="pug">
    .forminho
        form(name="submit-to-google-sheet")
            .pb-3
                label
                    input.form-control(type="radio" name="type" value="session")
                    .label-box
                        i.fas.fa-check
                    | {{ $t('BASE.TRAINING_TYPE') }}
                label
                    input.form-control(type="radio" name="type" value="demo")
                    .label-box
                        i.fas.fa-check
                    | {{ $t('BASE.PRESENTATION_TYPE') }}
            .pb-3
                p {{ $t('BASE.PREFERRED_DAY') }}
                label
                    input.form-control(type="radio" name="day" value="friday")
                    .label-box
                        i.fas.fa-check
                    | {{ $t('BASE.DAY_1') }}
                label
                    input.form-control(type="radio" name="day" value="saturday")
                    .label-box
                        i.fas.fa-check
                    | {{ $t('BASE.DAY_2') }}
                label
                    input.form-control(type="radio" name="day" value="sunday")
                    .label-box
                        i.fas.fa-check
                    | {{ $t('BASE.DAY_3') }}
            .pb-3
                p {{ $t('BASE.PREFERRED_TIME') }}
                label
                    input.form-control(type="radio" name="time" value="8-12am")
                    .label-box
                        i.fas.fa-check
                    | {{ $t('BASE.TIME_1') }}
                label
                    input.form-control(type="radio" name="time" value="12-4pm")
                    .label-box
                        i.fas.fa-check
                    | {{ $t('BASE.TIME_2') }}
                label
                    input.form-control(type="radio" name="time" value="4-8pm")
                    .label-box
                        i.fas.fa-check
                    | {{ $t('BASE.TIME_3') }}
            input.form-control.justfit-input(:placeholder="$t('BASE.YOUR_NAME')" type="text" autocomplete="name" name="name" required)
            input.form-control.justfit-input(:placeholder="$t('BASE.EMAIL')" type="email" autocomplete="email" name="email" required)
            textarea.form-control.justfit-input(:placeholder="$t('BASE.MESSAGE')" name="message" rows="4")
            .pb-3
                label
                    input.form-control(type="checkbox" name="agree" value="agreed" v-model="agreement")
                    .label-box
                        i.fas.fa-check
                    span(v-html="$t('BASE.AGREE')")
            justfit-button.small(variant="gradient" type="submit" small) {{ $t('BASE.SUBMIT_TEXT') }}
        .my-5.text-center.text-danger(v-if="isNotAgreed")
            h4 {{ $t('BASE.YOU_NEED_TO_AGREE') }}
        .my-5.text-center(v-if="sent")
            h4 {{ $t('BASE.SENT_FORM') }}
        .my-5.text-center(v-if="error")
            h4 {{ $t('BASE.ERROR_SENT_FORM') }}
</template>

<style lang="scss">
@import "../../assets/styles/settings/settings";
    .justfit-input {
        border: rem(1) solid $justfit-dark-green;
        background-color: $black;
        margin-bottom: rem(16);
        padding: rem(12) rem(12);
        height: 2.5rem;
    }
    .forminho {
        input[type='radio'], input[type='checkbox'] {
            display: none;
        }
        label {
            display: flex;
            align-items: center;
            .label-box {
                width: rem(24);
                height: rem(24);
                border: rem(1) solid $justfit-dark-green;
                background-color: $black;
                margin-right: rem(8);
                display: flex;
                align-items: center;
                justify-content: center;
                i {
                    display: none;
                    font-size: rem(18);
                    color: $justfit-green;
                }
            }
        }
        input[type='radio']:checked + .label-box  , input[type='checkbox']:checked + .label-box  {
            i {
                display: block;
            }
        }
    }

</style>
